import useGetRelatedProducts from '../../Hooks/useGetRelatedProducts'
import useGetSimilarProducts from '../../Hooks/useGetSimilarProducts'
import useGetProductsBySerial from '../../Hooks/useGetProductsBySerial'
import CustomSwiper from '../../../../Components/Components/CustomSwiper'

const elementsInPage = 12

export const RelatedProducts = ({ product, isMobile, maxWidth }) => {
    const { relatedProducts } = useGetRelatedProducts(product)
    let width = isMobile ? '500px' : maxWidth

    if (!relatedProducts || relatedProducts.length === 0) {
        return null
    }
    return (
        <div style={{ maxWidth: width }}>
            <CustomSwiper
                products={relatedProducts.slice(0, elementsInPage)}
                loop={false}
                refreshPage={false}
                autoPlay={false}
                isMobile={isMobile}
            />
        </div>
    )
}

// export const SimilarProducts = ({ product }) => {
//     const { similarProducts } = useGetSimilarProducts(product)
//     return (
//         similarProducts && similarProducts.slice(0, elementsInPage).map((similar, index) => (
//             <div key={index} className='col-3'>
//                 <ProductLight product={similar} />
//             </div>
//         ))
//     )
// }

export const SimilarProducts = ({ product, isMobile, maxWidth }) => {
    const { similarProducts } = useGetSimilarProducts(product)
    let width = isMobile ? '500px' : maxWidth

    if (!similarProducts || similarProducts.length === 0) {
        return null
    }

    return (
        <div style={{ maxWidth: width }}>
            <CustomSwiper
                products={similarProducts.slice(0, elementsInPage)}
                loop={false}
                refreshPage={false}
                autoPlay={false}
                isMobile={isMobile}
            />
        </div>
    )
}

export const ProductsWithSameSerial = ({ product, isMobile, maxWidth }) => {
    const { productsWithSameSerial } = useGetProductsBySerial(product)
    let width = isMobile ? '500px' : maxWidth

    if (!productsWithSameSerial || productsWithSameSerial.length === 0) {
        return null
    }
    return (
        <div style={{ maxWidth: width }}>
            <CustomSwiper
                products={productsWithSameSerial.slice(0, elementsInPage)}
                loop={false}
                refreshPage={false}
                autoPlay={false}
                isMobile={isMobile}
            />
        </div>
    )
}

